import Service from '@ember/service';
import sha1 from 'sha1';

export const HIBP_RANGE_API_URL = 'https://api.pwnedpasswords.com/range/';

export default class HibpService extends Service {
  #getHashedPasswordSegments(password: string) {
    let hashedPassword: string = sha1(password);

    return {
      prefix: hashedPassword.substring(0, 5),
      suffix: hashedPassword.substring(5),
    } as Record<string, string>;
  }

  async requestRange(hashedPasswordPrefix: string) {
    let result = await fetch(`${HIBP_RANGE_API_URL}${hashedPasswordPrefix}`);
    return result.text();
  }

  async isPasswordCompromised(password: string) {
    let { prefix, suffix } = this.#getHashedPasswordSegments(password);
    let upperCaseSuffix: string = suffix.toUpperCase();

    let hashSuffixes = await this.requestRange(prefix);

    let pwnedPassword = hashSuffixes
      ? hashSuffixes.split('\n').find((line: string) => line.includes(upperCaseSuffix))
      : undefined;

    return pwnedPassword ? pwnedPassword.split(':')[1] : false;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    hibp: HibpService;
  }
}
